import { useEffect, useState } from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import styled from "styled-components";
import { screenSizes } from "../../styles/theme";
import {
    walletOverview
} from "../../slices/connectWallet/connectWalletThunks";
import { useDispatch } from "react-redux";
import { showToast } from "../../slices/global/ToastSlice";

const ChartContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #fff;
  font-family: "Manrope", sans-serif;
  @media (max-width: ${screenSizes.L}px) {
    display: block;
  }
`;

const ChartWrapper = styled.div`
  position: relative;
  width: 60%;
  display: flex;
  flex-direction: column;
  @media (max-width: ${screenSizes.L}px) {
    width: 100%;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #000;
`;


const TitleFooter = styled.div`
      font-size: 18px;
    font-weight: 700;
    margin-bottom: 20px;
    color: #ff0000;
    position: absolute;
    right: 0;
    @media (max-width: ${screenSizes.L}px) {
        margin: auto;
        width: 100%;
        text-align: center;
        top: 8%;
    }
`;

const ResponsiveContainerWrapper = styled.div`
    width: 100%;
    height: 350px;
    margin-top: 50px;
    @media (max-width: ${screenSizes.L}px) {
        margin-top: 0;
    }
`;

const CenterText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  @media (max-width: ${screenSizes.L}px) {
        top: 45%;
    }
`;

const TotalText = styled.span`
    color: #091c005a;
    font-weight: 700;
    font-size: 12px;
`;

const ChangeWrapper = styled.div`
    font-size: 12px;
    font-weight: 700;
`;

const TotalAssets = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #000;
`;

const Change = styled.span`
  font-size: 14px;
  color: #4caf50;
  margin-top: 5px;
`;

const ChangeText = styled.span`
color: #091c00;
`

const LegendWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 30%;
  margin-top: -65px;
  @media (max-width: ${screenSizes.L}px) {
    margin-top: -135px;
    margin-left: 10px;
    width: 100%;
  }
`;

const LegendItem = styled.div`
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-bottom: 25px;
  @media (max-width: ${screenSizes.L}px) {
    margin-bottom: 10px;
  }
  span {
    font-size: 24px;
    font-weight: 700;
    margin-left: 15px;
  }
`;

const LegendLabel = styled.div`
  align-items: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
  font-size: 12px;
  line-height: 1.2em;
  word-wrap: break-word;
  @media (max-width: ${screenSizes.L}px) {
    max-width: 90%;
  }
`;

const LegendColor = styled.svg`
  height: 10px;
  width: 10px;
  border-radius: 50%;
  margin-right: 8px;
`;

const OverviewChart = (props: any) => {
    const isMobile = window.innerWidth <= 1024;
    const dispatch: any = useDispatch();
    const [isDataAvailable, setIsDataAvailable] = useState(false);
    const [totalAmount, setTotalAmount] = useState(0);
    const [PieChartData, setPieChartData] = useState([]);

    const [isDisabled, setIsDisabled] = useState(true); // Simulating a "not started yet" state


    const gradients = [
        {
            id: "gradient1",
            colors: ["#FF9D59", "#FFD580"],
        },
        {
            id: "gradient2",
            colors: ["#091C00", "#2A4D00"],
        },
        {
            id: "gradient3",
            colors: ["#6366F1", "#8A8DF4"],
        },
    ];

    const  pieChartDataDefault = [
        {
          "_id": "0x9cf42a2ba2bef4d258fb0193c17f0daf804951e1",
          "totalAmount": 3,
          "count": 3
        },
        {
            "_id": "0x9cf42a2ba2bef4d258fb0193c17f0daf80495345",
            "totalAmount": 5,
            "count": 5
        },
        {
            "_id": "0x9cf42a2ba2bef4d258fb0193c17f0daf80495345",
            "totalAmount": 8,
            "count": 8
        }
      ];

    const renderGradientDefs = () =>
        gradients.map((gradient) => (
            <linearGradient id={gradient.id} key={gradient.id} x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor={gradient.colors[0]} />
                <stop offset="100%" stopColor={gradient.colors[1]} />
            </linearGradient>
        ));

    const getOverviewDetails = async (
        walletAddress: string,
    ) => {
        dispatch(walletOverview({ walletAddress: walletAddress }))
            .then((res: any) => {

                if (res?.error) {
                    throw new Error(res?.error?.message);
                }

                setTotalAmount(res?.payload?.data?.data?.overallUserData?.totalAmount)
                let data = res?.payload?.data?.data?.byCollection.slice(0, 3);

                console.log('datadatadata', data);

                if(data.length <= 0){
                   data=pieChartDataDefault
                   setTotalAmount(3)
                   setIsDataAvailable(false);
                }else{
                    setIsDataAvailable(true);
                }

                const transformedData = data.map((item: { _id: any; count: any; totalAmount: any }, index: number) => ({
                    name: item._id,
                    value: item.count,
                    gradientId: gradients[index % gradients.length].id,
                    totalAmount: item.totalAmount
                }));

                setPieChartData(transformedData);

                
                
            })
            .catch((err: any) => {
                dispatch(
                    showToast({
                        message: err.message || "Something went wrong!",
                        severity: "error",
                    })
                );
            })
            .finally(() => { });
    };

    useEffect(() => {
        getOverviewDetails(props.walletAddress);
    }, [])

    return (
        <ChartContainer style={{background: !isDataAvailable ? "#ffffff" : "#ffffff"}}>
            <ChartWrapper>
                <Title>Discover Digital Assets</Title>
                {!isDataAvailable ? <TitleFooter>You haven't started yet</TitleFooter> : null}
                <ResponsiveContainerWrapper>
                    <ResponsiveContainer width="100%" height="100%">
                        <PieChart>
                            <defs>{renderGradientDefs()}</defs>
                            <Pie
                                data={PieChartData}
                                startAngle={180}
                                endAngle={0}
                                innerRadius={isMobile ? 125 : 150}
                                outerRadius={isMobile ? 150 : 180}
                                dataKey="value"
                                paddingAngle={1}
                                cornerRadius={isMobile ? 6 : 10}
                            >
                                {PieChartData.map((entry: any, index: any) => (
                                    <Cell key={`cell-${index}`} fill={`url(#${entry.gradientId})`} />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>
                </ResponsiveContainerWrapper>
                <CenterText>
                    <TotalText>Total assets</TotalText>
                    <TotalAssets>${(parseInt(String(totalAmount)).toFixed(2))}</TotalAssets>
                    {/* <ChangeWrapper>
                    <Change>+8%</Change>&nbsp;
                    <ChangeText>from last month</ChangeText>
                </ChangeWrapper> */}
                </CenterText>
                
            </ChartWrapper>

            <LegendWrapper>
                {PieChartData.map((entry: any, index: any) => (
                    <LegendItem key={index}>
                        <LegendLabel>
                            <LegendColor>
                                <circle cx="5" cy="5" r="5" fill={`url(#${entry.gradientId})`} />
                            </LegendColor>
                            {entry.name}
                        </LegendLabel>
                        <span>
                            $
                            {entry.totalAmount
                                ? entry.totalAmount.toLocaleString(undefined, { minimumFractionDigits: 2 })
                                : entry.value}
                        </span>
                    </LegendItem>
                ))}
                
            </LegendWrapper>
            
            
        </ChartContainer> 
    );
};

export default OverviewChart;
